import { render, staticRenderFns } from "./SystemActivityForm.vue?vue&type=template&id=5333697e&"
import script from "./SystemActivityForm.vue?vue&type=script&lang=js&"
export * from "./SystemActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports